import IconX from "@/assets/icons/x-lg.svg?react";
import { Button, Card } from "@lya-protect/lya-protect-form-library/dist/UI";
import classNames from "classnames";
import { ReactNode } from "react";
import style from "./InfoCard.module.scss";

type InfoCardProps = {
  children: ReactNode;
  className?: string;
  type?: "info" | "warning" | "error" | "success" | "neutral";
} & (CancelableCardProps | NonCancelableCardProps);

type CancelableCardProps = {
  onCancel: () => void;
  cancelButtonClassName?: string;
};

type NonCancelableCardProps = {
  onCancel?: never;
  cancelButtonClassName?: never;
};

export function InfoCard({
  children,
  className,
  type = "info",
  onCancel,
  cancelButtonClassName,
}: InfoCardProps) {
  return (
    <Card
      variant="outline"
      className={classNames(style.infoCard, style[type], className)}
    >
      <div className={style.content}>{children}</div>
      {onCancel && (
        <Button
          icon={<IconX />}
          onClick={onCancel}
          variant="text"
          className={classNames(style.cancelButton, cancelButtonClassName)}
        />
      )}
    </Card>
  );
}
